import { Trans, useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { EmptyInfo } from 'components/Pages/Wine/View/Main/Content/ColumnLeft/_styles'
import { StyledLink } from 'components/Common/MasterComponents'
import Collapsable from 'components/Pages/Wine/View/Common/Collapsable'
import DefaultTooltip from 'components/Common/Tooltips/DefaultTooltip'
import useUserRole from 'utils/user/useUserRole'
import { useCapturedWine } from '../../../_methods/context'
import { useProduct } from 'components/Pages/Wine/View/Main/_methods'

const List = styled.div`
  display: flex;
  flex-flow: row wrap;
  align-items: flex-start;
  padding: 0;
  gap: 8px;
`

const Item = styled.img`
  height: 47px;
  width: auto;
`

const TooltipContent = styled.div`
  text-align: center;
`

const Certificates = () => {
  const { t } = useTranslation()
  const product = useProduct()
  const { isAuthor, capturedWine, canEdit: canEditCtx } = useCapturedWine()
  const { isContent, isSuperAdmin } = useUserRole()
  const canEdit =
    canEditCtx !== undefined
      ? canEditCtx
      : isAuthor || isContent || isSuperAdmin

  const items = (product?.wine as any)?.certs ?? []
  const isEmpty = items.length === 0

  return (
    <Collapsable title={t('wine.view.certificates')}>
      {!isEmpty && (
        <List>
          {items.map((item: any) => (
            <DefaultTooltip
              key={item.id}
              component={Item}
              src={item.logo}
              alt=''
              placement='top'
              tooltip={<TooltipContent>{item.localizedName}</TooltipContent>}
              tooltipProps={{ maxWidth: '180px' }}
            />
          ))}
        </List>
      )}

      {isEmpty && canEdit && (
        <EmptyInfo>
          <Trans
            t={t}
            i18nKey='wine.view.noCertificates'
            components={[
              <StyledLink
                key={0}
                to={`/acc/captured-wine/${capturedWine.id}/edit/general`}
              />,
            ]}
          />
        </EmptyInfo>
      )}

      {isEmpty && !canEdit && (
        <EmptyInfo>{t('capturedWine.view.noCertificates')}</EmptyInfo>
      )}
    </Collapsable>
  )
}

export default Certificates
